import { Trans } from '@lingui/react';
import { Divider, ListItemButton } from '@mui/material';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import AlertText from 'components/AlertText';
import { BackfillWarningDto } from 'providers/api';
import React from 'react';

interface WarningListInputProps {
  acceptedWarnings: string[]; // warning.code
  warnings: BackfillWarningDto[];
  disabled: boolean;
  onChange: (code: string) => void;
}

const WarningListInput = ({ acceptedWarnings, warnings, disabled, onChange }: WarningListInputProps) => (
  <Box>
    <AlertText severity="error">
      <Trans id="The recipe in question contains the following warnings.
      In order to create a new pour from this recipe you are required to accept each warning by ticking the check box."
      >
        The recipe in question contains the following warnings.
        In order to create a new pour from this recipe you are required to accept each warning by ticking the check box.
      </Trans>
    </AlertText>
    <List component="nav" aria-label="main mailbox folders">
      <Divider />
      {
        warnings.map((warning: BackfillWarningDto) => (
          <React.Fragment key={warning.code}>
            <ListItem
              secondaryAction={(
                <Checkbox
                  disabled={disabled}
                  checked={acceptedWarnings.includes(warning.code ?? '')}
                  onChange={() => onChange(warning.code ?? '')}
                  color="secondary"
                />
              )}
            >
              <ListItemButton
                onClick={() => onChange(warning.code ?? '')}
              >
                <ListItemText primary={warning.display} />
              </ListItemButton>
            </ListItem>
            <Divider />
          </React.Fragment>
        ))
      }
    </List>
  </Box>
);

export default WarningListInput;
